import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { get_platform_banners } from "../store/reducers/homeReducer";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

const Banner = () => {
  const dispatch = useDispatch();
  const { platformBanners } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    dispatch(get_platform_banners());
  }, [dispatch]);

  const CustomLeftArrow = ({ onClick }) => {
    if (window.innerWidth <= 785) return null;
    return <></>;
  };

  return (
    <div className="w-full relative z-0">
      {platformBanners && platformBanners.length > 0 ? (
        <div className="w-full lg:w-[90%] mx-auto br">
          <div className="w-full flex flex-wrap">
            <div className="w-full">
              <div className="w-full">
                <Carousel
                  autoPlay={true}
                  infinite={true}
                  arrows={true}
                  showDots={false}
                  responsive={responsive}
                  customLeftArrow={<CustomLeftArrow />}
                >
                  {platformBanners.map((banner, index) => (
                    <div key={banner._id || index} className="lg-md:h-[320px] h-[180px] sm:h-[240px] md:h-[320px] w-full block">
                      {banner.link ? (
                        <Link to={banner.link} className="block w-full h-full">
                          <img
                            className="nex_banner_img sm:rounded-[30px] w-full h-full object-cover"
                            src={banner.image}
                            alt={banner.title || `Banner ${index + 1}`}
                            title={banner.description || banner.title}
                          />
                        </Link>
                      ) : (
                        <img
                          className="nex_banner_img sm:rounded-[30px] w-full h-full object-cover"
                          src={banner.image}
                          alt={banner.title || `Banner ${index + 1}`}
                          title={banner.description || banner.title}
                        />
                      )}
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
